import { Column, ColumnInstance, TableState, UseGlobalFiltersOptions } from 'react-table';
import { EnumFilterableColumn } from '../DataGrid';

export function useMappedAndPersistedColumns<T extends Record<string, unknown>>(
  columns: (Column<T> | EnumFilterableColumn<T>)[],
  shouldPersist = false,
  persistedGridState: TableState<object> | undefined,
) {
  columns.map((column) => {
    if (column['sortType'] == undefined) {
      column.sortType = 'customAlphaNumericSort';
    }

    // Restore column widths if persistent data grid settings in use
    if (shouldPersist && persistedGridState?.columnResizing) {
      if (typeof column.Header === 'string' && persistedGridState.columnResizing.columnWidths[column.Header]) {
        column.width = persistedGridState.columnResizing.columnWidths[column.Header];
      }
    }
  });
}

export function useOriginalColumnOrder<T extends Record<string, unknown>>(
  columns: (Column<T> | EnumFilterableColumn<T>)[] | ColumnInstance<T>[],
) {
  return {
    columns: columns.map((column) => column['accessor']?.toString() ?? ''),
  };
}

export function useColumnVisibility<T extends Record<string, unknown>>(
  hiddenColumn: ColumnInstance<T>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tableOptions?: { [key: string]: any },
  useGlobalFilterOptions?: UseGlobalFiltersOptions<T>,
) {
  // if the column or table setting is not explicitly set to false, toggle the visibility.
  if (useGlobalFilterOptions?.disableGlobalFilter !== false && tableOptions?.disableGlobalFilter !== false) {
    // columns on initial load have disableGlobalFilter set to undefined, so this is explicitly setting disableGlobalFilter
    hiddenColumn.disableGlobalFilter =
      hiddenColumn.disableGlobalFilter !== undefined ? !hiddenColumn.disableGlobalFilter : hiddenColumn.isVisible;
  }

  return {
    columnId: hiddenColumn.id,
    currentHiddenColumn: hiddenColumn,
  };
}
